export function capitalize(lower: string) {
  return lower.charAt(0).toUpperCase() + lower.substring(1);
}
